// extracted by mini-css-extract-plugin
export default {"table":"MyDashboard_table__sya-l","stickyTabs":"MyDashboard_stickyTabs__QmLHE","tabs__myReadfingList":"MyDashboard_tabs__myReadfingList__lUfZO"};